import { Component } from 'vue-property-decorator';
import TombolaBaseComponent from '@/components/base/base.component';

@Component({
  name: 'ScrollableContainerComponent'
})
export default class ScrollableContainerComponent extends TombolaBaseComponent {
  public scrollToBottom() {
    const $contentDiv = this.$el;
    if ($contentDiv) {
      $contentDiv.scrollTop = $contentDiv.scrollHeight;
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/shared-components/scrollable-container/scrollable-container.component.ts